import { render, staticRenderFns } from "./CertificateListAddNew.vue?vue&type=template&id=143850c2&"
import script from "./CertificateListAddNew.vue?vue&type=script&lang=js&"
export * from "./CertificateListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./CertificateListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports